export const AUDIT_ANSWER = {
  YES: 'yes',
  PARTIAL: 'partial',
  NO: 'no',
};

export const ANSWER_SCORE = {
  [AUDIT_ANSWER.YES]: 1,
  [AUDIT_ANSWER.PARTIAL]: 0.5,
  [AUDIT_ANSWER.NO]: 0,
};

export const AUDIT_SECTIONS = [
  {
    id: 'offer',
    title: 'Оффер и продукт',
    items: [
      { id: 'offer_value', weight: 10, title: 'Понятно, что продаёте и чем отличаетесь', hint: 'Клиент за 5 секунд понимает ценность' },
      { id: 'offer_price', weight: 8, title: 'Цена или вилка цен указаны', hint: 'Нет «узнавайте в личке» без контекста' },
    ],
  },
  {
    id: 'landing',
    title: 'Посадочная страница',
    items: [
      { id: 'landing_mobile', weight: 10, title: 'Сайт удобен на телефоне', hint: 'Кнопки крупные, текст читается' },
      { id: 'landing_speed', weight: 8, title: 'Страница грузится быстро', hint: 'Нет долгого ожидания на 4G' },
      { id: 'landing_cta', weight: 10, title: 'Один главный призыв к действию', hint: 'Оставить заявку / написать / позвонить' },
    ],
  },
  {
    id: 'leads',
    title: 'Приём и обработка заявок',
    items: [
      { id: 'leads_capture', weight: 12, title: 'Форма или мессенджер принимает заявки', hint: 'Проверено тестовой заявкой' },
      { id: 'leads_notify', weight: 10, title: 'Уведомления о новых лидах работают', hint: 'Почта, Telegram, CRM — не теряются' },
      { id: 'leads_sla', weight: 10, title: 'Ответ клиенту до 15 минут в рабочее время', hint: 'Скорость сильно влияет на конверсию' },
    ],
  },
  {
    id: 'analytics',
    title: 'Аналитика и пиксель',
    items: [
      { id: 'analytics_pixel', weight: 12, title: 'Пиксель Meta / аналитика установлены', hint: 'События «лид» видны в кабинете' },
      { id: 'analytics_goals', weight: 10, title: 'Настроены цели конверсии', hint: 'Заявка, звонок, покупка — что считаем успехом' },
      { id: 'analytics_utm', weight: 8, title: 'UTM-метки для рекламы', hint: 'Понимаете, откуда пришёл лид' },
    ],
  },
  {
    id: 'ops',
    title: 'Процессы и запуск',
    items: [
      { id: 'ops_crm', weight: 10, title: 'Лиды фиксируются в CRM или таблице', hint: 'Статусы: новый → в работе → сделка' },
      { id: 'ops_creatives', weight: 8, title: 'Есть креативы или материалы для рекламы', hint: 'Фото/видео, тексты, офферы' },
      { id: 'ops_kpi', weight: 10, title: 'Знаете целевой CPL или ROMI', hint: 'CPL — стоимость лида, ROMI — возврат на рекламные вложения в %' },
    ],
  },
  {
    id: 'legal',
    title: 'Юридическое',
    items: [
      { id: 'legal_privacy', weight: 6, title: 'Политика конфиденциальности на сайте', hint: 'Особенно если собираете персональные данные' },
    ],
  },
];

export const getAllAuditItems = () =>
  AUDIT_SECTIONS.flatMap((section) =>
    section.items.map((item) => ({ ...item, sectionId: section.id })),
  );

export const getDefaultAnswers = () => {
  const answers = {};
  getAllAuditItems().forEach((item) => {
    answers[item.id] = null;
  });
  return answers;
};

export const calculateAuditScore = (answers) => {
  const items = getAllAuditItems();
  let totalWeight = 0;
  let earnedWeight = 0;
  const gaps = [];

  items.forEach((item) => {
    totalWeight += item.weight;
    const answer = answers[item.id];

    if (!answer) {
      return;
    }

    const score = ANSWER_SCORE[answer] ?? 0;
    earnedWeight += item.weight * score;

    if (answer === AUDIT_ANSWER.NO || answer === AUDIT_ANSWER.PARTIAL) {
      gaps.push({
        ...item,
        answer,
        priority: item.weight * (answer === AUDIT_ANSWER.NO ? 1 : 0.6),
      });
    }
  });

  const answeredCount = items.filter((item) => answers[item.id]).length;
  const percent =
    answeredCount > 0 && totalWeight > 0 ? Math.round((earnedWeight / totalWeight) * 100) : 0;

  gaps.sort((a, b) => b.priority - a.priority);

  return {
    percent,
    answeredCount,
    totalCount: items.length,
    isComplete: answeredCount === items.length,
    statusKey: getStatusKey(percent),
    topGaps: gaps.slice(0, 3),
    allGaps: gaps,
  };
};

export const getStatusKey = (percent) => {
  if (percent < 50) {
    return 'STATUS_EARLY';
  }

  if (percent < 80) {
    return 'STATUS_ALMOST';
  }

  return 'STATUS_READY';
};

export const HOW_STEPS = [
  { num: '1', title: 'Каждый пункт имеет вес.', text: '«Да» = 100% балла, «Частично» = 50%, «Нет» = 0%. Итог — сумма взвешенных баллов.' },
  { num: '2', title: 'Пороги готовности:', text: 'до 50% — рано, 50–79% — доработать, 80%+ — можно запускать тест.' },
  { num: '3', title: 'Список «Сделать в первую очередь»', text: 'показывает пункты с ответом «Нет» и «Частично» по приоритету веса.' },
];
